import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { getVersion } from '../api/Services';
import { getEqNames } from '../api/analysis';
import { TextContext } from './TextCotext';

const ContextInfo = (props) => {
  const lastFilterRef = useRef(null);
  const [showDatePicker, setShowDatePicker] = useState(true);
  const [loading, seLoading] = useState(false);

  const [allDevice, setAllDevice] = useState([]);
  const [socketData, setSocketData] = useState({});
  const [socketAlarm, setSocketAlarm] = useState([]);
  const [devicesList, setDevicesList] = useState([]);
  const [inverterList, setInverterList] = useState([]);
  const [equipmentsError, setEquipmentsError] = useState({});
  const [osSocketPayload, setOsSocketPayload] = useState({});
  const [OSList, setOSList] = useState([]);
  const [playAlarm, setPlayAlarm] = useState(false);
  const [alarmCount, setAlarmCount] = useState(0);
  const [alarmHappenSocket, setAlarmHappenSocket] = useState([]);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  // useEffect(() => {
  // console.log(equipmentsError);
  // }, [equipmentsError]);

  // ایجاد payload مورد نیاز برای سوکت device data
  const handleCreateDeviceDataPayload = (equipments) => {
    const payload = equipments?.map((item) => ({
      category: item.model.category,
      equipments: [item?.ID],
      name: 'OS',
    }));
    const INVERTERS = payload?.filter((item) => item?.category === 'INVERTER');

    setOsSocketPayload({
      all: payload,
      inverters: INVERTERS,
    });
  };

  const handleAlarmList = async (equit, force = false) => {
    if (!force && lastFilterRef.current === equit) return;
    lastFilterRef.current = equit
    seLoading(true);
    try {
      // const { data } = await getDeviceByPhase(equit);
      const { data } = await getEqNames(equit);
      const Equipments = data.result;
      setAllDevice(Equipments);
      handleCreateDeviceDataPayload(Equipments);
      if (equit == 'ALL') {
        // console.log(data.result)
        setInverterList(data.result);
      }
      seLoading(false);
    } catch (ex) {
      console.log(ex);
      seLoading(false);
    }
  };

  useEffect(() => {
    handleGetSocketData();
    const intervalId = setInterval(() => {
      handleGetSocketData();
    }, 4000);

    // Clean up the interval when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, [socketData, allDevice, equipmentsError, OSList]);

  const handleGetSocketData = async () => {
    const info = await Promise.all(
      (allDevice || []).map(async (item) => {
        const sourceArray = Array.isArray(socketData?.raw)
          ? socketData.raw
          : Object.values(socketData?.raw || {});
        const statusColor = sourceArray.find(
          (obj) => obj.equipment_id == item.ID,
        );

        const color = handleEquipmentsColor(statusColor);
        const status =
          color.color === 'gray'
            ? 'Disconnect'
            : color.alarmCategory === 'powerAC'
            ? color.status
            : handleSetStatus(item);

        return {
          ...item,
          // Status: statusColor == undefined ? null : statusColor?.status,
          Color: color.color,
          Status: status,
          alarmCategory: color.alarmCategory,
          // Color: statusColor == undefined ? 'green' : statusColor?.color,
          date:
            statusColor == undefined
              ? '--'
              : moment(statusColor?.date).format('YYYY-MM-DD (HH:mm)'),
          StatusColor:
            statusColor?.color == 'red'
              ? '#f00707'
              : // : statusColor?.color == 'green'
              // ? '#07f021'
              statusColor?.color == 'gray'
              ? '#A0A09F'
              : statusColor?.color == 'yellow'
              ? '#FFCD2F'
              : '#07f021',
        };
      }),
    );
    // console.log(info)
    setDevicesList(info);
    const groupedDevices = info?.reduce((acc, device) => {
      const phaseName = device.phase?.Name || device.model.category;
      if (!acc[phaseName]) {
        acc[phaseName] = [];
      }
      acc[phaseName].push(device);
      return acc;
    }, {});

    setSocketAlarm(groupedDevices);
  };

  // handle Equipments Color
  const handleEquipmentsColor = (error) => {
    // اگر خطایی برای تجهیز وجود ندارد، مقدار پیش‌فرض برگردانده می‌شود
    if (!error || !error.equipment_id) {
      return { color: 'green', alarmCategory: 'normal', status: null };
    }

    const { equipment_id } = error;
    const errors = equipmentsError[equipment_id];

    // اگر خطایی برای تجهیز وجود نداشته باشد، مقدار پیش‌فرض برمی‌گردد
    if (!errors || errors.length === 0) {
      return { color: 'green', alarmCategory: 'normal', status: null };
    }

    // اولویت‌بندی خطاها
    const errorPriority = {
      DISCONNECTED: 1,
      SHUTDOWN: 2,
      STATUS: 3,
      CUSTOM: 4,
      LOWPOWER: 5,
    };

    // مرتب‌سازی خطاها بر اساس اولویت
    const sortedErrors = errors.sort(
      (a, b) => errorPriority[a.alarmCategory] - errorPriority[b.alarmCategory],
    );

    const topPriorityError = sortedErrors[0];

    // مقدار برگشتی شامل رنگ، دسته‌بندی خطا و وضعیت
    return {
      color: topPriorityError.color,
      alarmCategory: topPriorityError.alarmCategory,
      status: topPriorityError.status,
    };
  };

  const handleSetStatus = (equipment) => {
    // Get equipment status from the list of statuses
    const setStatus = OSList?.find((i) => i.equipment_id == equipment.ID);

    if (setStatus) return +setStatus.value;
  };

  //  ----------****----------projects version ----------****----------
  useEffect(() => {
    handleGetVersion();
  }, []);
  const [version, setVersion] = useState('');
  const handleGetVersion = async () => {
    try {
      const { data } = await getVersion();
      setVersion(data.result.version);
    } catch (err) {
      console.log(err);
    }
  };
  // -----------------------------********------------------------------------

  return (
    <TextContext.Provider
      value={{
        allDevice,
        socketAlarm,
        setSocketAlarm,
        handleAlarmList,
        socketData,
        setSocketData,
        showDatePicker,
        setShowDatePicker,
        loading,
        devicesList,
        version,
        inverterList,
        setEquipmentsError,
        osSocketPayload,
        setOSList,
        playAlarm,
        setPlayAlarm,
        alarmCount,
        setAlarmCount,
        alarmHappenSocket,
        setAlarmHappenSocket,
        isErrorModalVisible,
        setIsErrorModalVisible,
      }}
    >
      {props.children}
    </TextContext.Provider>
  );
};

export default ContextInfo;
